import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/full-header-overlay-box.module.css";

interface Props {
  absolute?: boolean;
  className?: string;
  children: ReactNode;
}

const FullHeaderOverlayBox: FunctionComponent<Props> = ({
  absolute,
  className,
  children,
}) => {
  return (
    <div
      className={ClassNames(
        styles.FullHeaderOverlay__Box,
        { [styles["FullHeaderOverlay__Box--absolute"]]: absolute },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default FullHeaderOverlayBox;
